import { useContext } from "react"
import AuthContext from "../../admin/AuthContext"

const useAuthContext = () => useContext(AuthContext)
export default useAuthContext
